import { _axios } from "../../../Utils/Axios/axios";

export const removePdfRequestsService = async (userToken: string) => {
  const data = new FormData();

  return _axios.post("/clear-pdf-list", data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
